export enum CertificateIssuanceType {
    EMAIL = "EMAIL",
    PICKUP = "PICKUP"
}